import {
  DocumentTemplate,
  DocumentTemplateHTMLContent,
} from '@app/types/document-template';
import { urls } from '@api/urls.ts';
import axiosInstance from '@api/axios.ts';

export const deleteDocumentTemplate = async (
  id: DocumentTemplate['id']
): Promise<void> => {
  const response = await axiosInstance.delete(urls.documentTemplate.byId(id));

  return response.data;
};

export const getDocumentInstanceHTMLTemplate = async (
  id: number
): Promise<DocumentTemplateHTMLContent> => {
  const response = await axiosInstance.get(
    urls.documentTemplate.getHtmlTemplate(id)
  );

  return response.data;
};
